export function formatCHF(value) {
    if (value === undefined) {
        return 'n.a.';
    }
    const parsed = typeof value === 'string'
        ? Number(value.replace(/'/g, '').trim())
        : value;
    if (isNaN(parsed)) {
        return 'n.a.';
    }
    return new Intl.NumberFormat('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(parsed);
}
